import { render, staticRenderFns } from "./WorkforceSearchInput.vue?vue&type=template&id=2a3188ae&scoped=true&"
import script from "./WorkforceSearchInput.vue?vue&type=script&lang=js&"
export * from "./WorkforceSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./WorkforceSearchInput.vue?vue&type=style&index=0&id=2a3188ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3188ae",
  null
  
)

export default component.exports